/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransferDuration } from './TransferDuration';
import {
    TransferDurationFromJSON,
    TransferDurationFromJSONTyped,
    TransferDurationToJSON,
    TransferDurationToJSONTyped,
} from './TransferDuration';

/**
 * 
 * @export
 * @interface TransferPartner
 */
export interface TransferPartner {
    /**
     * 
     * @type {string}
     * @memberof TransferPartner
     */
    fromLoyaltyProgram: string;
    /**
     * 
     * @type {string}
     * @memberof TransferPartner
     */
    toLoyaltyProgram: string;
    /**
     * 
     * @type {number}
     * @memberof TransferPartner
     */
    transferRatio: number;
    /**
     * 
     * @type {TransferDuration}
     * @memberof TransferPartner
     */
    transferTime?: TransferDuration;
    /**
     * Active transfer bonus as a percentage (30 means 30% more destination points). Absent when no bonus is running.
     * @type {number}
     * @memberof TransferPartner
     */
    bonusPercent?: number;
    /**
     * Last day the active bonus applies. Absent when no bonus is running or the end date is unknown.
     * @type {Date}
     * @memberof TransferPartner
     */
    bonusEndsOn?: Date;
}



/**
 * Check if a given object implements the TransferPartner interface.
 */
export function instanceOfTransferPartner(value: object): value is TransferPartner {
    if (!('fromLoyaltyProgram' in value) || value['fromLoyaltyProgram'] === undefined) return false;
    if (!('toLoyaltyProgram' in value) || value['toLoyaltyProgram'] === undefined) return false;
    if (!('transferRatio' in value) || value['transferRatio'] === undefined) return false;
    return true;
}

export function TransferPartnerFromJSON(json: any): TransferPartner {
    return TransferPartnerFromJSONTyped(json, false);
}

export function TransferPartnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferPartner {
    if (json == null) {
        return json;
    }
    return {
        
        'fromLoyaltyProgram': json['from_loyalty_program'],
        'toLoyaltyProgram': json['to_loyalty_program'],
        'transferRatio': json['transfer_ratio'],
        'transferTime': json['transfer_time'] == null ? undefined : TransferDurationFromJSON(json['transfer_time']),
        'bonusPercent': json['bonus_percent'] == null ? undefined : json['bonus_percent'],
        'bonusEndsOn': json['bonus_ends_on'] == null ? undefined : (new Date(json['bonus_ends_on'])),
    };
}

export function TransferPartnerToJSON(json: any): TransferPartner {
    return TransferPartnerToJSONTyped(json, false);
}

export function TransferPartnerToJSONTyped(value?: TransferPartner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from_loyalty_program': value['fromLoyaltyProgram'],
        'to_loyalty_program': value['toLoyaltyProgram'],
        'transfer_ratio': value['transferRatio'],
        'transfer_time': TransferDurationToJSON(value['transferTime']),
        'bonus_percent': value['bonusPercent'],
        'bonus_ends_on': value['bonusEndsOn'] == null ? value['bonusEndsOn'] : value['bonusEndsOn'].toISOString().substring(0,10),
    };
}

